import { styled } from "../theme";
export const ThinScrollbar = styled.div `
  * {
    scrollbar-width: thin;
  }

  *::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }

  *::-webkit-scrollbar-button {
    width: 0px;
    height: 0px;
  }

  *::-webkit-scrollbar-thumb {
    background: #bec7d2;
    border: none;
    border-radius: 30px;
  }

  *::-webkit-scrollbar-thumb:hover {
    background: #d4deea;
  }

  *::-webkit-scrollbar-thumb:active {
    background: #82888f;
  }

  *::-webkit-scrollbar-track {
    background: #f1f2f5;
    border: none;
    border-radius: 30px;
  }

  *::-webkit-scrollbar-track:hover {
    background: #f1f2f5;
  }

  *::-webkit-scrollbar-track:active {
    background: #f1f2f5;
  }

  *::-webkit-scrollbar-corner {
    background: transparent;
  }
`;
export const ThinScrollbarArea = styled(ThinScrollbar) `
  overflow: auto;
  overflow: overlay; // don't work with Firefox
  height: 100%;
  padding-inline-end: 1rem;

  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }

  &::-webkit-scrollbar-button {
    width: 0px;
    height: 0px;
  }

  &::-webkit-scrollbar-thumb {
    background: #bec7d2;
    border: none;
    border-radius: 30px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #d4deea;
  }

  &::-webkit-scrollbar-thumb:active {
    background: #82888f;
  }

  &::-webkit-scrollbar-track {
    background: #f1f2f5;
    border: none;
    border-radius: 30px;
  }

  &::-webkit-scrollbar-track:hover {
    background: #f1f2f5;
  }

  &::-webkit-scrollbar-track:active {
    background: #f1f2f5;
  }

  &::-webkit-scrollbar-corner {
    background: transparent;
  }
`;
